import { render, staticRenderFns } from "./NoContainer.vue?vue&type=template&id=6dd0a0d7&"
var script = {}


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports